import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { Radio } from 'antd'

export const Container = styled(Flex)`
  padding: 20px 25px 20px 15px;
  // border-bottom: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  //  background-color: #ffffff;
  //   z-index: 99;
  //   position: sticky !important;
  //   top: 0 !important;
`
export const Main = styled.div`
  position: sticky;
  top: 0;
  z-index: 1001;
`
export const LeftSection = styled(Flex)`
  gap: 10px;
  display: flex;
  align-items: flex-end;
`
export const RightSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #4d566e;
`
export const SectionWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  height: 100%;
  margin-top: -11px;
`

export const CustomDiv = styled.div`
  cursor: pointer;
`
export const DropDownText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 28px;
  color: #000000;
  margin-left: 23px;
  margin-bottom: 15px;
  margin-top: 15px;
`
export const DropDownAttributes = styled.div`
  margin-top: 20px;
  margin-left: 20px;
`

export const AttributeText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
`
export const LeftStyles = styled.div`
  margin-left: 20px;
`
export const ExportContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  margin-top: 30px;
`
export const ExportText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`
export const DataText = styled.div`
  color: #808697;
  font-size: 15px;
  font-weight: 500;
`
export const FilterContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  // gap: 10;
  margin-left: 20px;
`
export const ModalContainer = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 15px;
`
export const CheckBoxItem = styled.div`
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  padding: 5px;
`
export const CustomExportButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`

export const CustomRadioGroup = styled(Radio.Group)`
  .ant-radio-inner {
    background-color: transparent !important;
    border-color: #d9d9d9 !important;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #3249d7 !important;
  }

  .ant-radio-checked .ant-radio-inner::after {
    background-color: #3249d7 !important;
  }
  .ant-radio-wrapper {
    color: #696969 !important;
    font-weight: 600 !important;
  }
`
